/*!

=========================================================
* Black Dashboard React v1.2.2 — customizado Toca da Onça
=========================================================

* Base: Creative Tim (MIT). Menu adaptado para o CRM da Toca da Onça Modas.

=========================================================

*/
import Dashboard from "views/Dashboard.js";
import Cerebro from "views/Cerebro.js";
import Catalogo from "views/Catalogo.js";
import Notifications from "views/Notifications.js";
import TableList from "views/TableList.js";
import Typography from "views/Typography.js";
import UserProfile from "views/UserProfile.js";
import Canais from "views/Canais.js";
import Marketplace from "views/Marketplace.js";
import Agentes from "views/Agentes.js";
import Regioes from "views/Regioes.js";
import Fornecedores from "views/Fornecedores.js";
import AnaliseMercado from "views/AnaliseMercado.js";
import Aniversarios from "views/Aniversarios.js";
import NetworkingEmpresas from "views/NetworkingEmpresas.js";
import PDV from "views/PDV.js";

var routes = [
  {
    path: "/cerebro",
    name: "Cérebro Único",
    rtlName: "الدماغ",
    icon: "tim-icons icon-atom",
    component: <Cerebro />,
    layout: "/admin",
  },
  {
    path: "/dashboard",
    name: "Painel Geral",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/tables",
    name: "Clientes",
    rtlName: "قائمة الجدول",
    icon: "tim-icons icon-single-02",
    component: <TableList />,
    layout: "/admin",
  },
  {
    path: "/aniversarios",
    name: "Aniversariantes",
    rtlName: "أعياد الميلاد",
    icon: "tim-icons icon-gift-2",
    component: <Aniversarios />,
    layout: "/admin",
  },
  {
    path: "/catalogo",
    name: "Catálogo",
    rtlName: "فهرس",
    icon: "tim-icons icon-image-02",
    component: <Catalogo />,
    layout: "/admin",
  },
  {
    path: "/pdv",
    name: "PDV — Ponto de Venda",
    rtlName: "نقطة البيع",
    icon: "tim-icons icon-barcode",
    component: <PDV />,
    layout: "/admin",
  },
  {
    path: "/notifications",
    name: "Caixa & Vendas",
    rtlName: "إخطارات",
    icon: "tim-icons icon-money-coins",
    component: <Notifications />,
    layout: "/admin",
  },
  {
    path: "/user-profile",
    name: "Vendedores",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-badge",
    component: <UserProfile />,
    layout: "/admin",
  },
  {
    path: "/canais",
    name: "Canais",
    rtlName: "الرموز",
    icon: "tim-icons icon-world",
    component: <Canais />,
    layout: "/admin",
  },
  {
    path: "/marketplace",
    name: "Marketplace",
    rtlName: "متجر",
    icon: "tim-icons icon-cart",
    component: <Marketplace />,
    layout: "/admin",
  },
  {
    path: "/analise-mercado",
    name: "Análise de Mercado",
    rtlName: "تحليل",
    icon: "tim-icons icon-chart-bar-32",
    component: <AnaliseMercado />,
    layout: "/admin",
  },
  {
    path: "/agentes",
    name: "Agentes & IA",
    rtlName: "الوكلاء",
    icon: "tim-icons icon-atom",
    component: <Agentes />,
    layout: "/admin",
  },
  {
    path: "/regioes",
    name: "Regiões",
    rtlName: "خرائط",
    icon: "tim-icons icon-pin",
    component: <Regioes />,
    layout: "/admin",
  },
  {
    path: "/fornecedores",
    name: "Fornecedores",
    rtlName: "الموردين",
    icon: "tim-icons icon-bag-16",
    component: <Fornecedores />,
    layout: "/admin",
  },
  {
    path: "/networking",
    name: "Networking Empresas",
    rtlName: "الشبكات",
    icon: "tim-icons icon-bank",
    component: <NetworkingEmpresas />,
    layout: "/admin",
  },
  {
    path: "/typography",
    name: "Relatórios",
    rtlName: "طباعة",
    icon: "tim-icons icon-align-center",
    component: <Typography />,
    layout: "/admin",
  },
];
export default routes;
